import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// import "./customForm.scss";
import uploadIcon from "../../../../Assets/icons/uploadicon.svg";
import jobcardIcon from "../../../../Assets/icons/JobCardPlusIcon.svg";
import addcomplaiIcon from "../../../../Assets/icons/addcomplain.svg";
import downloadIcon from "../../../../Assets/icons/download.svg";
// import axiosInstance from "../../services/api/API";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import Switch from "react-switch";
import axiosInstance from "../../../../http.common";

const SalesDynamicForm = ({
  formConfig,
  formData,
  setFormData = () => {},
  validationErrors,
  setValidationErrors = () => {},
  showParentDesignation,
  setShowParentDesignation = () => {},
  images,
  buttonOnclick,
  addComplainHandler,
  cities,
  onclickOpenFrom = () => {},
  handledownload,
  setResponseErrorMessage = () => {},
  taxVal
}) => {
  console.log("validationErrors", validationErrors);
  const [fileNames, setFileNames] = useState({})
  const [pincode, setPincode] = useState("");
  const [pincodeData,setPincodeData]= useState([])
  const token = localStorage.getItem("authToken");
  const datePickerRefs = useRef({});

 
  

  useEffect(() => {
    if (pincode.length === 6 || formData?.pincode?.length===6) {
      const fetchPincodeData = async () => {
        try {
          const response = await axiosInstance.post(
            "/pincodestatecity/getbypincode",
            {
              pincode: pincode,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.status === 200) {
            const data = response?.data?.data[0];
            if (!data || data===undefined) {
              
              setPincodeData(data)
              setResponseErrorMessage("Invalid PinCode*")
            }
            else {
              setPincodeData(data)
              
              setResponseErrorMessage('')
            }
           
            setFormData((prevData) => ({
              ...prevData,
              city: data?.city_name,
              city_id: data?.city_id,
              state: data?.state_name,
              state_id: data?.state_id,
              country: data?.country_name,
              country_id: data?.country_id,
            }));
          } else {
            throw new Error("Failed to fetch data");
          } 
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchPincodeData();
    }
    console.log(formData, "PINcode");
  }, [pincode]);
 
  useEffect(() => {
    if (formData?.pincode?.length === 6) {
     
      setPincode(formData?.pincode);
    }
  }, [formData?.pincode]);


  const handleChange = (name, value, type) => {
    console.log(name, value, "namevalueforfile");
  
    // Handle checkbox and upload file logic
    if (type === "checkbox" || type === "toggle") {
      // Your existing logic for checkboxes
      if (name == "extendedToggle" && value == true) {
        console.log("name>>", name, value);
        setShowParentDesignation(true);
      } else {
        setShowParentDesignation(false);
      }
      setFormData({ ...formData, [name]: value });
      console.log("formdata???", formData);
    } else if (type === "uploadFile") {
      // Your existing logic for file uploads
    } else {
      // Update formData for regular inputs
      setFormData({ ...formData, [name]: value });
    }
  
    // If the changed field is part of the calculations
    if (["platecharges", "insurance", "rto_amount", "accessories", "discount", "discounttype", "taxset_id", "finance_amount", "custsubsidyprice", "cust_subsidy_price", "exshowroom_price"].includes(name)) {
      console.log("Updated value for", name, ":", value);
  
      // Call the function to recalculate totals and tax
      calculateTotals(name, value);
    }
  
    if (name === "pincode") {
      setPincode(value);
    }
  
    if (name === "goods_quantity") {
      const goodsQuantity = parseFloat(value) || 0;
      const exshowroomPrice = parseFloat(formData.purchase_price) || 0;
      const total = exshowroomPrice * goodsQuantity;
  
      setFormData((prevFormData) => ({
        ...prevFormData,
        total: total,
      }));
    }
  
    validateField(name, value);
  };
  
//   const calculateTotals = (name, value) => {
//     // Convert all relevant fields to numbers using the current formData state
//     let plateCharges = parseFloat(formData.platecharges) || 0;
//     let insurance = parseFloat(formData.insurance) || 0;
//     let rtoAmount = parseFloat(formData.rto_amount) || 0;
//     let accessories = parseFloat(formData.accessories) || 0;
//     let exshowroomPrice = parseFloat(formData.exshowroomprice) || 0;
//     let discount = parseFloat(formData.discount) || 0;
//     let discountType = formData.discounttype || "a"; // Default discount type to "a" if not set
  
//     // Update the field that was changed
//     if (name === "platecharges") {
//       plateCharges = parseFloat(value) || 0;
//     } else if (name === "insurance") {
//       insurance = parseFloat(value) || 0;
//     } else if (name === "rto_amount") {
//       rtoAmount = parseFloat(value) || 0;
//     } else if (name === "accessories") {
//       accessories = parseFloat(value) || 0;
//     } else if (name === "discount") {
//       discount = parseFloat(value) || 0;
//     } else if (name === "discounttype") {
//       discountType = value; // Set directly since it's a string
//     }
  
//     // Base total without discount
//     let total = exshowroomPrice + plateCharges + insurance + rtoAmount + accessories;
//     console.log("Total before discount:", total);

//     let mainTotalwithoutTax = total; // This stores the total before discount

// // Apply discount based on discount type
// if (discountType === "a") {
//   total -= discount; // Subtract discount amount directly
// } else if (discountType === "p") {
//   const discountAmount = (total * discount) / 100; // Calculate discount amount
//   total -= discountAmount; // Subtract discount percentage
// }

// // Calculate the total after discount is applied
// let totalWithDiscount = total; // This will give the total after discount has been applied

// console.log(mainTotalwithoutTax, "mainTotalwithoutTax");
// console.log(totalWithDiscount, "Total after discount");
     
  
//     // Round the total
//     const roundedTotal = Math.round(total);
  
//     // Calculate tax amount based on selected tax set
//     const selectedTax = taxVal?.find(option => option?.value === formData?.taxset_id);
//     const taxPercent = selectedTax ? parseFloat(selectedTax.percent) : 0;
//     const taxAmount = (totalWithDiscount * taxPercent) / 100; // Calculate tax amount
  
//     // Calculate payable amount (balance total)
//     let balanceTotal = totalWithDiscount + taxAmount;
  
//     // Subtract finance amount if it exists
//     const financeAmount = parseFloat(formData.finance_amount) || 0;
//     if (financeAmount > 0) {
//       balanceTotal -= financeAmount; // Subtract finance amount from balance total
//     }
  
//     // Log the values to the console
//     console.log("Total Onroad Price after Discount:", total);
//     console.log("Rounded Onroad Price:", roundedTotal);
//     console.log("Tax Amount:", taxAmount);
//     console.log("Balance Total (Payable Amount):", balanceTotal);
  
//     // Update the formData for onroadprice, onboardPriceRoundoff, and balance_amount
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       onroadprice: totalWithDiscount,
//       onboardPriceRoundoff: roundedTotal,
//       balance_amount: roundedTotal,
//     }));
//   };

useEffect(() => {
  // Parse values from formData
  const exshowroomPrice = parseFloat(formData.exshowroomprice || formData.exshowroom_price) || 0;
  const custsubsidyprice = parseFloat(formData.custsubsidyprice || formData.cust_subsidy_price) || 0;

  let plateCharges = parseFloat(formData.platecharges) || 0;
  let insurance = parseFloat(formData.insurance) || 0;
  let rtoAmount = parseFloat(formData.rto_amount) || 0;
  let accessories = parseFloat(formData.accessories) || 0;
  let taxamount = parseFloat(formData.taxamount) || 0;
  let discountType = formData.discounttype || "a"; // Default discount type to "a" if not set
  let financeAmount = parseFloat(formData.finance_amount) || 0;

  // Calculate the final price
  const finalPrice = exshowroomPrice - custsubsidyprice;

  const finalPriceAfterAllCalc = finalPrice + plateCharges + insurance + rtoAmount + accessories + taxamount

  // Update the finalPrice in the formData state
  setFormData(prevFormData => ({
    ...prevFormData,
    finalPrice: finalPrice,
    onroadprice: finalPriceAfterAllCalc,
    onboardPriceRoundoff: finalPriceAfterAllCalc,
    balance_amount:finalPriceAfterAllCalc
     // Store the calculated final price
  }));
}, [formData.exshowroomprice, formData.custsubsidyprice, formData.platecharges, formData.insurance, formData.rto_amount, formData.accessories]);
  
const calculateTotals = (name, value) => {
  // Convert all relevant fields to numbers using the current formData state
  let plateCharges = parseFloat(formData.platecharges) || 0;
  let insurance = parseFloat(formData.insurance) || 0;
  let rtoAmount = parseFloat(formData.rto_amount) || 0;
  let accessories = parseFloat(formData.accessories) || 0;
  let exshowroomPrice = parseFloat(formData.exshowroomprice || formData.exshowroom_price) || 0;
  let discount = parseFloat(formData.discount) || 0;
  let discountType = formData.discounttype || "a"; // Default discount type to "a" if not set
  let financeAmount = parseFloat(formData.finance_amount) || 0;
  let custsubsidyprice = parseFloat(formData.custsubsidyprice || formData.cust_subsidy_price) || 0;

  // Update the field that was changed
  if (name === "platecharges") {
    plateCharges = parseFloat(value) || 0;
  } else if (name === "insurance") {
    insurance = parseFloat(value) || 0;
  } else if (name === "rto_amount") {
    rtoAmount = parseFloat(value) || 0;
  } else if (name === "accessories") {
    accessories = parseFloat(value) || 0;
  } else if (name === "discount") {
    discount = parseFloat(value) || 0;
  } else if (name === "discounttype") {
    discountType = value; // Set directly since it's a string
  } else if (name === "finance_amount") {
    financeAmount = parseFloat(value) || 0;
  } else if (name === "exshowroomprice") {
    exshowroomPrice = parseFloat(value) || 0;
  } else if (name === "custsubsidyprice" || "cust_subsidy_price") {
    custsubsidyprice = parseFloat(value) || 0;
  }

  // Calculate the final price
  let finalPrice = exshowroomPrice - custsubsidyprice;

  // Base total without discount
  let total = finalPrice + plateCharges + insurance + rtoAmount + accessories;
  console.log("Total before discount:", total);

  let mainTotalwithoutTax = total; // Total before discount

  // Apply discount based on discount type
  if (discountType === "A") {
    total -= discount; // Subtract discount amount directly
  } else if (discountType === "P") {
    const discountAmount = (total * discount) / 100; // Calculate discount amount
    total -= discountAmount; // Subtract discount percentage
  }

  // Calculate the total after discount
  let totalWithDiscount = total;
  console.log(mainTotalwithoutTax, "mainTotalwithoutTax");
  console.log(totalWithDiscount, "Total after discount");
  console.log(finalPrice, "finalPrice");

  // Round the total
  const roundedTotal = Math.round(totalWithDiscount);

  // Fetch the selected tax set from formData to calculate tax
  const selectedTax = taxVal?.find(option => option?.value === formData?.taxset_id);
  const taxPercent = selectedTax ? parseFloat(selectedTax.percent) : 0;

  // Calculate tax amount based on the selected tax rate
  const taxAmount = parseFloat(((totalWithDiscount * taxPercent) / 100).toFixed(2));
  console.log("Tax Amount:", taxAmount);

  // Calculate payable amount (balance total)
  let balanceTotal = totalWithDiscount + taxAmount;
  balanceTotal = parseFloat(balanceTotal.toFixed(2));

  // Subtract finance amount if it exists
  let resultofFinanceBalance = balanceTotal; // Initialize the result with balanceTotal

  if (financeAmount > 0) {
    resultofFinanceBalance = balanceTotal - financeAmount; // Adjust balance if finance amount is present
  }

  // Log the values to the console
  console.log("Total Onroad Price after Discount:", totalWithDiscount);
  console.log("Rounded Onroad Price:", roundedTotal);
  console.log("Balance Total (Payable Amount):", balanceTotal);
  console.log("Balance Total after Finance:", resultofFinanceBalance);


  setFormData((prevFormData) => ({
    ...prevFormData,
    onroadprice: balanceTotal,
    onboardPriceRoundoff: Math.round(balanceTotal),
    taxamount: taxAmount, // Ensure taxamount is always set
    balance_amount: financeAmount > 0 ? resultofFinanceBalance : Math.round(balanceTotal),
    finalPrice: finalPrice // Update final price here
  }));
};


  const validateField = (name, value) => {
    const fieldConfig = formConfig?.find((field) => field.name === name);
    if (fieldConfig && fieldConfig?.validation) {
      const { required, minLength, maxLength, maxValue, pattern, message,accept,responseerrormessage } =
        fieldConfig.validation;
      let error = "";
      if (name === "uploadDocument") {
       const file = value?.name;
       const fileExtension = file?.split('.').pop().toLowerCase();
          console.log("fileExtension",fileExtension);
       if (accept && !accept.includes(fileExtension)) {
         error = `Invalid file format. Allowed formats: ${accept}`;
       }
     }
      if (name === "gstno") {
        const panValue = formData?.panno; 
        console.log("valuelength", value?.length);

      
        if (value?.length !== 0) {
        
          if (
            !panValue ||
            panValue.length !== 10 ||
            !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panValue)
          ) {
            error = "Invalid PAN format, GST validation requires a valid PAN";
          }
         
          else if (value.length !== 15) {
            error = "GST number must be 15 characters long";
          }
          
          else {
            const gstPanPart = value.substring(2, 12);
            if (gstPanPart !== panValue) {
              error = "GST number is not valid as per the PAN number";
            }
          }
        }
      }
      console.log("responseerrormessage",responseerrormessage);
      if (required && (value === undefined || value === null || value === "")) {
        console.log("value", value);
        error = "This field is required*";
      } else if (value.length > 0 && value.length < minLength) {
        error = `Minimum length ${minLength} characters`;
      } else if (value.length > 0 && maxLength && value.length > maxLength) {
        error = `Maximum length ${maxLength} characters`;
      } else if (required && maxValue && value > maxValue) {
        error = `Quantity  Exceeded`;
      } else if (value?.length > 0 && pattern && !pattern.test(value)) {
        error = `${message}`;
      }
      else if (value?.length > 0 && responseerrormessage?.length>0 ) {
        error = `${responseerrormessage}`;
      }
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));
    }
  };
  useEffect(() => {
    if (images && images.length > 0) {
      const initialFileNames = {};
      const initialFormData = {};
      images.forEach((image) => {
        initialFileNames[image?.document_type] = image?.document;
        initialFormData[image?.document_type] = image?.image_path;
      });
      setFileNames(initialFileNames);
      setFormData((prevData) => ({
        ...prevData,
        ...initialFormData,
      }));
    }
  }, [images, setFormData]);

 
useEffect(()=>{
  if(formData?.exchange){
    setShowParentDesignation(true);
  }
},[formData?.exchange])
  const handleMultiSelectChange = (name, selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setFormData({ ...formData, [name]: selectedValues });
    validateField(name, selectedValues);
  };


  // const handleDropdownChange = (name, selectedOption) => {
  //   console.log("selected options", name, selectedOption);
  
  //   if (name === "taxset_id") {
  //     // Find the selected tax set from taxVal
  //     const selectedTax = taxVal?.find(option => option?.value === selectedOption.value);
  //     console.log(selectedTax, "SELECTEDTAX");
  
  //     // Parse the tax percent, or set it to 0 if not found
  //     const taxPercent = selectedTax ? parseFloat(selectedTax.percent) : 0;
  
  //     // Calculate the total amount (adjust this based on your requirements)
  //     const exshowroomPrice = parseFloat(formData.exshowroomprice) || 0;
  //     const plateCharges = parseFloat(formData.platecharges) || 0;
  //     const insurance = parseFloat(formData.insurance) || 0;
  //     const rtoAmount = parseFloat(formData.rto_amount) || 0;
  //     const accessories = parseFloat(formData.accessories) || 0;
  //     let custsubsidyprice = parseFloat(formData.custsubsidyprice || formData.cust_subsidy_price) || 0;

  //     let finalPrice = exshowroomPrice - custsubsidyprice;
  
  //     // Calculate the total before tax and discount
  //     let total = finalPrice + plateCharges + insurance + rtoAmount + accessories;
  
  //     // Apply discount logic
  //     const discount = parseFloat(formData.discount) || 0;
  //     const discountType = formData.discounttype || "A"; // Default to amount discount
  
  //     if (discountType === "A") {
  //       total -= discount; // Subtract discount directly
  //     } else if (discountType === "P") {
  //       const discountAmount = (total * discount) / 100;
  //       total -= discountAmount;
  //     }
  
  //     // Calculate the tax amount based on the selected tax rate
  //     // const taxAmount = (total * taxPercent) / 100;
      
  //     const taxAmount = parseFloat(((total * taxPercent) / 100).toFixed(2)); // Calculate tax amount
  //     console.log("Tax Amount:", taxAmount);
      
  //     let balanceAmount = total + taxAmount; // Calculate the final balance amount (including tax)
  //     balanceAmount = parseFloat(balanceAmount.toFixed(2));
  //     // Check if finance_amount is present and subtract it from balance_amount
  //     const financeAmount = parseFloat(formData.finance_amount) || 0;
      
  //     const roundedBalanceAmount = Math.round(balanceAmount); // Round off balance amount

  //     let resultofFinanceBalance = roundedBalanceAmount; // Initialize the result with balanceTotal

  // if (financeAmount > 0) {
  //   resultofFinanceBalance = roundedBalanceAmount - financeAmount; // Adjust balance if finance amount is present
  // }
      
  //     // Set form data with the calculated tax, balance amounts, and onboardPriceRoundoff
  //     setFormData(prevFormData => ({
  //       ...prevFormData,
  //       [name]: selectedOption?.value, // Set the selected tax set ID
  //       taxamount: taxAmount, // Set the calculated tax amount
  //       onroadprice: balanceAmount, // Set the balance amount in onroadprice
  //       // balance_amount: roundedBalanceAmount, // Set the payable amount
  //       balance_amount: financeAmount > 0 ? resultofFinanceBalance : roundedBalanceAmount,
  //       onboardPriceRoundoff: roundedBalanceAmount, // Set the rounded balance amount
  //       finalPrice: finalPrice
  //     }));
  //   } else if (name === "productName") {
  //     setFormData({
  //       ...formData,
  //       [name]: selectedOption.value,
  //       subproductName: null,
  //       makeName: null,
  //     });
  //   } else if (name === "city") {
  //     const selectedCity = cities?.find(
  //       (city) => city.city_id === selectedOption.value
  //     );
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: selectedOption.label,
  //       city_id: selectedOption?.value,
  //       state: selectedCity.state_name,
  //       state_id: selectedCity.state_id,
  //       country: selectedCity.country_name,
  //       country_id: selectedCity.country_id,
  //     }));
  //   } else {
  //     setFormData({ ...formData, [name]: selectedOption?.value });
  //   }
  
  //   validateField(name, selectedOption ? selectedOption?.value : null);
  // };
  

  const handleDropdownChange = (name, selectedOption) => {
    if (name === "taxset_id") {
      const selectedTax = taxVal?.find(option => option?.value === selectedOption.value);
      const taxPercent = selectedTax ? parseFloat(selectedTax.percent) : 0;
  
      const exshowroomPrice = parseFloat(formData.exshowroomprice) || 0;
      const plateCharges = parseFloat(formData.platecharges) || 0;
      const insurance = parseFloat(formData.insurance) || 0;
      const rtoAmount = parseFloat(formData.rto_amount) || 0;
      const accessories = parseFloat(formData.accessories) || 0;
      let custsubsidyprice = parseFloat(formData.custsubsidyprice || formData.cust_subsidy_price) || 0;
      
      let finalPrice = exshowroomPrice - custsubsidyprice;
      let total = finalPrice + plateCharges + insurance + rtoAmount + accessories;
  
      const discount = parseFloat(formData.discount) || 0;
      const discountType = formData.discounttype || "A";
  
      if (discountType === "A") {
        total -= discount;
      } else if (discountType === "P") {
        total -= (total * discount) / 100;
      }
  
      const taxAmount = parseFloat(((total * taxPercent) / 100).toFixed(2));
      let balanceAmount = total + taxAmount;
      balanceAmount = parseFloat(balanceAmount.toFixed(2));
      const financeAmount = parseFloat(formData.finance_amount) || 0;
      const roundedBalanceAmount = Math.round(balanceAmount);
      let resultofFinanceBalance = roundedBalanceAmount;
  
      if (financeAmount > 0) {
        resultofFinanceBalance = roundedBalanceAmount - financeAmount;
      }
  
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: selectedOption?.value,
        taxamount: taxAmount,
        onroadprice: balanceAmount,
        balance_amount: financeAmount > 0 ? resultofFinanceBalance : roundedBalanceAmount,
        onboardPriceRoundoff: roundedBalanceAmount,
        finalPrice: finalPrice
      }));
    } else {
      // Handle other dropdown changes...
      setFormData({ ...formData, [name]: selectedOption?.value });
    }
  
    validateField(name, selectedOption ? selectedOption?.value : null);
  };
  
  
  
  

  const handleRichTextChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
    validateField(name, value);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: "#ccc",
      boxShadow: "none",
      borderRadius: "10px",
      "&:hover": {
        borderColor: "#888",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      height: "50px",
      width: "200px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "5px",
      borderColor: "#ccc",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#7BD755"
        : state.isFocused
        ? "#fff"
        : null,
      // color: state.isSelected || state.isFocused ? "white" : "black",
      "&:hover": {
        backgroundColor: "#f2fcf0",
        color: "#000",
      },
    }),
  };

  const handleFileDrop = (e, name) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setFormData({ ...formData, [name]: file });
    setFileNames({ ...fileNames, [name]: file.name });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const renderField = (field) => {
    const additionalClass = field.gridClass ? ` ${field.gridClass}` : "";
    switch (field.type) {
      case "text":
      case "email":
      case "number":
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div
              className={`dropdown-wrapper ${
                field?.isaccessory ? "isCustomer" : ""
              }`}
              style={{ display: "flex", alignItems: "center" }}
            >
            <input
              type={field?.type}
              name={field?.name}
              value={formData[field?.name] || ""}
              placeholder={field?.placeholder || ""}
              disabled={field?.disabled}
              // minLength={2}
              maxLength={field?.validation && field?.validation?.maxLength}
              onChange={(e) =>
                handleChange(field.name, e.target.value, field.type)
              }
              className={`form-control ${
                validationErrors[field?.name] && "is-invalid"
              }`}
            />
            {field?.isaccessory && (
                <div
                  style={{
                    marginLeft: 10,
                    borderRadius: 10,
                    width: 50,
                    cursor: "pointer",
                  }}
                  onClick={addComplainHandler}
                >
                  <img src={jobcardIcon} alt="Job Card Icon" />
                </div>
              )}
              </div>
            {validationErrors[field?.name] && (
              <div className="error-feedback">
                {validationErrors[field?.name] }
              </div>
            )}
          </div>
        );
      case "textarea":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <textarea
              name={field.name}
              value={formData[field.name] || ""}
              placeholder={field.placeholder || ""}
              disabled={field.disabled}
              maxLength={field?.validation?.maxLength}
              rows={field.rows || 4}
              onChange={(e) =>
                handleChange(field.name, e.target.value, "textarea")
              }
              className={`form-control ${
                validationErrors[field.name] && "is-invalid"
              }`}
            />
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );

      case "radio":
        return (
          <div key={field?.name} className={`${additionalClass} mt-3 mb-3`}>
            <div className="radiocontainer">
              <label>{field?.label}</label>

              {field?.options.map((option) => (
                <div key={option.value} className="form-check">
                  <input
                    type="radio"
                    name={field?.name}
                    value={option?.value}
                    checked={formData[field?.name] === option.value}
                    onChange={(e) =>
                      handleChange(field.name, e.target.value, "radio")
                    }
                    className="form-check-input"
                  />
                  <label className="form-check-label">{option.label}</label>
                </div>
              ))}
            </div>
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "multiselectcheckbox":
        return (
          <div
            key={field.name}
            className={`form-group${additionalClass} mt-3 mb-3`}
          >
            <label className="mt-3 mb-3 filelabel">
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="checkbox-container">
              {field.options.map((option) => (
                <div key={option.value} className="checkbox-item">
                  <input
                    type="checkbox"
                    name={option?.value}
                    checked={formData[option?.value] || false}
                    onChange={(e) =>
                      handleChange(option?.value, e.target.checked, "checkbox")
                    }
                    className="form-check-input"
                  />
                  <label className="form-check-label">{option?.label}</label>
                  {option.value === "totalUsers" && (
                    <input
                      style={{ width: "65px", height: "30px" }}
                      type="number"
                      name="totalUsersCount"
                      value={formData.totalUsersCount || ""}
                      onChange={(e) =>
                        handleChange(
                          "totalUsersCount",
                          e.target.value,
                          "number"
                        )
                      }
                      className="form-control"
                    />
                  )}
                  {option.value === "maxhierarchy" && (
                    <input
                      style={{ width: "65px", height: "30px" }}
                      type="number"
                      name="maxhierarchy"
                      value={formData.maxhierarchy || ""}
                      onChange={(e) =>
                        handleChange("maxhierarchy", e.target.value, "number")
                      }
                      className="form-control"
                    />
                  )}
                  {option.value === "userPrefix" && (
                    <input
                      style={{ width: "65px", height: "30px" }}
                      type="text"
                      name="userPrefix"
                      value={formData?.userPrefix || ""}
                      onChange={(e) =>
                        handleChange("userPrefix", e.target.value, "text")
                      }
                      className="form-control"
                    />
                  )}
                </div>
              ))}
            </div>
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "multiselectdropdown":
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <Select
              isMulti
              name={field?.name}
              options={field?.options}
              styles={customStyles}
              //value={formData[field.name] || []}
              value={field?.options.filter((option) =>
                formData[field.name]?.includes(option.value)
              )}
              onChange={(selectedOptions) =>
                handleMultiSelectChange(field?.name, selectedOptions)
              }
              className={`select-control ${
                validationErrors[field.name] && "is-invalid"
              }`}
            />
            {validationErrors[field?.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );

      case "dropdown":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field?.label}
              {field?.required && <span className="required-asterisk">*</span>}
            </label>
            <div
              className={`dropdown-wrapper ${
                field?.iscustomer ? "isCustomer" : ""
              }`}
              style={{ display: "flex", alignItems: "center" }}
            >
              <div style={{ flexGrow: 1 }}>
                <Select
                  isClearable
                  key={field.name}
                  name={field.name}
                  isDisabled={field?.disabled}
                  options={field?.options}
                  styles={customStyles}
                  defaultValue={formData[field.name] || field.defaultValue}
                  value={
                    field?.options?.find(
                      (option) => option?.value === formData[field?.name]
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    handleDropdownChange(field?.name, selectedOption)
                  }
                  menuPlacement={field?.dropdownOptionsListPosition || "auto"}
                />
              </div>
              {field?.iscustomer && (
                <div
                  style={{
                    marginLeft: 10,
                    borderRadius: 10,
                    width: 50,
                    cursor: "pointer",
                  }}
                  onClick={onclickOpenFrom}
                >
                  <img src={jobcardIcon} alt="Job Card Icon" />
                </div>
              )}
            </div>
            {validationErrors[field.name] && (
              <div className="customerror">{validationErrors[field.name]}</div>
            )}
          </div>
        );

      case "richeditor":
        return (
          <div
            style={{ paddingTop: "10px" }}
            key={field?.name}
            className={`form-group${additionalClass}`}
          >
            <label style={{ paddingRight: "260px" }} className="pt-2 pr-4">
              {field?.label}
            </label>
            <ReactQuill
              value={formData[field?.name] || ""}
              onChange={(value) => handleRichTextChange(field?.name, value)}
              className="rich-editor"
              modules={{
                toolbar: {
                  container: [
                    ["bold", "italic", "underline", "strike"],
                    [{ header: "1" }, { header: "2" }, { font: [] }],
                    [{ size: [] }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link", "image", "video"],
                    ["clean"],
                  ],
                },
              }}
            />
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );

      case "uploadFile":
        return (
          <>
            <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              {field.label}
            </label>
            <div className="customFileUploadd">
              <div key={field.name} className={`form-group${additionalClass}`}>
                <div
                  className="file-drop-area pt-3"
                  onDrop={(e) => handleFileDrop(e, field.name)}
                  onDragOver={handleDragOver}
                >
                
                  <div className="">
                    <div className="custom-file-upload">
                      <input
                        type="file"
                        name={field.name}
                        id={field.name}
                        onChange={(e) =>
                          handleChange(field.name, e.target.files[0])
                        }
                        className="file-input"
                        style={{ display: "none" }}
                      />
                      <label htmlFor={field.name} className="custom-file-label">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img src={uploadIcon} />
                          {fileNames[field.name] || (
                            <div>
                              <p style={{ fontSize: "15px" }}>
                                Drag your files here or{" "}
                                <span style={{ color: "#7BD755" }}>Browse</span>
                              </p>
                              <p
                                style={{ fontSize: "14px", fontWeight: "300" }}
                              >
                                ((File Format - Xlsx, CSV))
                              </p>
                            </div>
                          )}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                {validationErrors[field.name] ? (
  <div className="error-feedback">
    {validationErrors[field.name]}
  </div>
) : formData[field.name] ? (
  <div style={{ marginTop: "10px", color:'#7BD755' }}>
    File Uploaded successfully
  </div>
) : null}
               
              </div>
            </div>
          </>
        );

        case "file":
          return (
            <>
              <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                {field.label}
              </label>
              <div key={field.name} className={`form-group${additionalClass}`}>
                <div
                  className="file-drop-area"
                  onDrop={(e) => handleFileDrop(e, field.name)}
                  onDragOver={handleDragOver}
                >
                  <div className="customFileUpload">
                    <div className="custom-file-upload">
                      <input
                        type="file"
                        name={field.name}
                        id={field.name}
                        onChange={(e) =>
                          handleChange(field.name, e.target.files[0])
                        }
                        className="file-input"
                        style={{ display: "none" }}
                      />
                      <label htmlFor={field.name} className="custom-file-label">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img src={uploadIcon} />
                          {fileNames[field.name] || (
                            <div>
                              <p style={{ fontSize: "15px" }}>
                                Drag your files here or{" "}
                                <span style={{ color: "#7BD755" }}>Browse</span>
                              </p>
                              <p style={{ fontSize: "14px", fontWeight: "300" }}>
                                (File Format - JPG, PNG)
                              </p>
                            </div>
                          )}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                {validationErrors[field.name] && (
                  <div className="invalid-feedback">
                    {validationErrors[field.name]}
                  </div>
                )}
              
                
              {formData[field.name] ? (
                typeof formData[field.name] === "string" ? ( // Check if it's a URL
                  <div style={{ marginTop: "10px" }}>
                    <a
                      href={formData[field.name]} // Use the URL for the existing image
                      download // This attribute makes it downloadable
                      style={{ textDecoration: "none", color: "#7BD755" }}
                      target="_blank"
                    >
                      <img
                        src={formData[field.name]} // Use the URL for the existing image
                        alt="uploaded"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          marginTop: "10px",
                        }}
                      />
  
                     
                    </a>
                  </div>
                ) : (
                  <a
                  href={URL.createObjectURL(formData[field.name])} // Create a temporary URL
                  download // This attribute makes it downloadable
                  style={{ textDecoration: "none", color: "#7BD755" }}
                  target="_blank"
                >
                  <img
                    src={URL.createObjectURL(formData[field.name])} // Generate URL for the uploaded image
                    alt="uploaded"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      marginTop: "10px",
                    }}
                  />
                  </a>
                )
              ) : (
                <div style={{ marginTop: "10px" }}>
                  <p style={{ fontSize: "15px", color: "#7BD755" }}>
                    {`No file uploaded`}
                  </p>
                </div>
              )}
              </div>
            </>
          );

      case "agentfile":
        return (
          <>
            <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              {field.label}
            </label>
            <div key={field.name} className={`form-group${additionalClass}`}>
              <div
                className="file-drop-area"
                onDrop={(e) => handleFileDrop(e, field.name)}
                onDragOver={handleDragOver}
              >
               
                <div className="customFileUpload">
                  <div className="custom-file-upload">
                    <input
                      type="file"
                      name={field.name}
                      id={field.name}
                      onChange={(e) =>
                        handleChange(field.name, e.target.files[0])
                      }
                      className="file-input"
                      style={{ display: "none" }}
                    />
                    <label htmlFor={field.name} className="custom-file-label">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img src={uploadIcon} />
                        {fileNames[field.name] || (
                          <div>
                            <p style={{ fontSize: "15px" }}>
                              Drag your files here or{" "}
                              <span style={{ color: "#7BD755" }}>Browse</span>
                            </p>
                            <p style={{ fontSize: "14px", fontWeight: "300" }}>
                              (File Format - JPG, PNG)
                            </p>
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              {validationErrors[field.name] && (
                <div className="error-feedback">
                  {validationErrors[field.name]}
                </div>
              )}
            
              {formData[field.name] ? (
                <div style={{ marginTop: "10px" }}>
                  <p style={{ fontSize: "15px", color: "#7BD755" }}>
                 { formData[field.name].name}
                  </p>
                </div>
              ) : null}
            </div>
          </>
        );

  

      case "button":
        return (
          <div className=" mt-1 mb-2">
            <label>{""}</label>
            <div className="downloadiconwrapper " onClick={buttonOnclick}>
              <label>{field.label}</label>
            </div>
          </div>
        );

      case "downloadbutton":
        return (
          <div
            style={{ marginTop: "35px" }}
            className="downloadiconwrapperr "
            onClick={handledownload}
          >
            <img className="downloadIcon" src={downloadIcon} />
            <a className="downloadHeading">Download</a>
          </div>
        );

      case "complainbutton":
        return (
          <div className="formbutton " onClick={addComplainHandler}>
            <img src={addcomplaiIcon} />
            <button className="complainbutton">Add Complain</button>
          </div>
        );
      case "date":
     
        const openDatePicker = (fieldName) => {
          if (datePickerRefs.current[fieldName]) {
            datePickerRefs.current[fieldName].setFocus();
          }
        };

        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="input-group">
              <DatePicker
                ref={(ref) => (datePickerRefs.current[field.name] = ref)}
                placeholderText="DD/MM/YYYY"
                disabled={field?.disabled ? true : false}
                selected={
                  formData[field?.name] ? new Date(formData[field.name]) : null
                }
                onChange={(date) => handleChange(field.name, date, "date")}
                // dateFormat="yyyy-MM-dd"
                dateFormat="dd/MM/yyyy"
                className={`form-control ${
                  validationErrors[field.name] && "is-invalid"
                }`}
                minDate={field?.minDate}
                maxDate={field?.maxDate}
                showMonthDropdown      // Show month dropdown
                showYearDropdown       // Show year dropdown
                 dropdownMode="select"  // Makes the dropdown in "select" mode
              />
              <span
                className="input-group-text"
                onClick={() => openDatePicker(field.name)}
                style={{ cursor: "pointer" }}
              >
                <FaCalendarAlt />
              </span>
            </div>
            {validationErrors[field.name] && (
              <div className="error-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "datetime":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="input-group">
              <DatePicker
                ref={datePickerRefs}
                disabled={field?.disabled ? true : false}
                selected={
                  formData[field.name] ? new Date(formData[field.name]) : null
                }
                onChange={(date) => handleChange(field.name, date, "datetime")}
                showTimeSelect
                 dateFormat="dd/MM/yyyy"
                placeholderText="DD/MM/YYYY"
                maxDate={field.maxDate}
                minDate={field.minDate}
                className={`form-control ${
                  validationErrors[field.name] && "is-invalid"
                }`}
              />
              <div className="input-group-append">
                <span
                  className="input-group-text"
                  onClick={() => datePickerRefs.current.setFocus()}
                >
                  <FaCalendarAlt />
                </span>
              </div>
            </div>
            {validationErrors[field.name] && (
              <div className="error-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "toggle":
        return (
          <div
            key={field?.name}
            className={`${additionalClass} mt-3 mb-3 togglecontainer`}
          >
            <Switch
              checked={formData[field?.name] || false}
              onChange={(checked) =>
                handleChange(field?.name, checked, "toggle")
              }
              onColor="#7BD755"
              onHandleColor="#7BD755"
              handleDiameter={30}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              height={20}
              width={48}
              className="react-switch"
              id="material-switch"
              disabled={field?.disabled ? true : false}
            />
            <label className="mt-3 mb-3">{field.label}</label>
            {validationErrors[field?.name] && (
              <div className="invalid-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="row">
   
      {formConfig?.map((field) => (
        <div key={field?.name} className={`${field.gridClass}`}>
          {(showParentDesignation || field?.isVisible !== false) &&
            renderField(field)}
         
        </div>
      ))}
    
    </div>
  );
};

export default SalesDynamicForm;
